module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-toyota.9a685ec0.png";